import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webTerms`

export const getTermsApi = () => {
    return axiosInstance.get(`${serverUrl}/get`)
}

export const addOrUpdateTermsApi = (formData) => {
    return axiosInstance.post(`${serverUrl}/create-update`, formData)
}

export const deleteTermsApi = (id) => {
    return axiosInstance.delete(`${serverUrl}/${id}`)
}

const termsService = {
    getTerms: getTermsApi,
    saveTermsApi: addOrUpdateTermsApi,
    deleteTermsApi
}

export default termsService
